const ko = {
  ID_BUMPER_AD_INFO: "{count}초 후 광고를 건너뛸 수 있습니다.",
  ID_BUMPER_AD_SKIP_BTN: "광고 건너뛰기",
};

export default ko;
